import ScreenView from './ScreenView'

export default ScreenView;